export function translateLogEventType(logEventType: any): string {
    const translatedLogEventType = logEventType.toString().toLowerCase().replaceAll('_', ' ');
    return `${logEventType.charAt(0)}${translatedLogEventType.slice(1)}`;
}
